import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import { NAV } from "../../data";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-white/80 backdrop-blur-xl border-b border-gray-200"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 lg:px-8 h-16 flex items-center justify-between">
        <button onClick={() => scrollTo("inicio")} data-testid="nav-home">
          <Logo />
        </button>

        <div className="hidden lg:flex items-center gap-7">
          {NAV.map((n) =>
            n.to ? (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.label.toLowerCase()}`}
                className="text-sm font-bold text-espana-red hover:text-espana-reddark transition-colors"
              >
                {n.label}
              </Link>
            ) : (
              <button
                key={n.id}
                data-testid={`nav-${n.id}`}
                onClick={() => scrollTo(n.id)}
                className="text-sm font-medium text-gray-600 hover:text-espana-red transition-colors"
              >
                {n.label}
              </button>
            )
          )}
        </div>

        <button
          data-testid="nav-cta"
          onClick={() => scrollTo("contacto")}
          className="hidden lg:inline-flex items-center bg-espana-red hover:bg-espana-reddark text-white text-sm font-bold px-5 py-2.5 rounded-sm transition-colors"
        >
          Colabora
        </button>

        <button
          className="lg:hidden text-gray-800"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-white border-t border-gray-200 px-5 py-4 flex flex-col gap-1">
          {NAV.map((n) =>
            n.to ? (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`nav-mobile-${n.label.toLowerCase()}`}
                onClick={() => setOpen(false)}
                className="text-left py-2.5 text-base font-bold text-espana-red"
              >
                {n.label}
              </Link>
            ) : (
              <button
                key={n.id}
                data-testid={`nav-mobile-${n.id}`}
                onClick={() => {
                  scrollTo(n.id);
                  setOpen(false);
                }}
                className="text-left py-2.5 text-base font-medium text-gray-700 hover:text-espana-red transition-colors"
              >
                {n.label}
              </button>
            )
          )}
          <button
            onClick={() => {
              scrollTo("contacto");
              setOpen(false);
            }}
            className="mt-2 bg-espana-red text-white font-bold px-5 py-3 rounded-sm"
            data-testid="nav-mobile-cta"
          >
            Colabora
          </button>
        </div>
      )}
    </header>
  );
}
